import { render } from "./menu.vue?vue&type=template&id=4770c2dd&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=4770c2dd&lang=scss&scoped=true"

import exportComponent from "E:\\projects\\resturant2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4770c2dd"]])

export default __exports__